<template>
  <div>
    <div class="header">
      <div class="switch-data-type" v-show="picked_function !== 'bill-query'">
        <div v-for="type, index in data_units" :key="index" class="switch-btn" @click="pickUnit(type)"
          :class="{ 'selected': picked_unit === type }">
          {{ dataTypeFormat(type) }}
        </div>
      </div>
      <div class="switch-time-format" v-show="data_type === 'lineChart'">
        <div v-for="unit, index in time_unit" :key="index" class="switch-btn"
          :class="{ 'selected': time_format === unit }" @click="switchTimeFormat(unit)">
          {{ timeUnitFormat(unit) }}
        </div>
      </div>
      <div class="chart-title" v-show="picked_function === 'bill-query'">當月電費趨勢</div>
    </div>
    <canvas id="line-chart" v-if="data_type === 'lineChart'" ref="lineChart"></canvas>
    <canvas id="bar-chart" v-if="data_type === 'barChart'" ref="barChart"></canvas>
  </div>
</template>

<script>
import { chartMixin } from '../mixins/chartMixin';

export default {
  mixins: [chartMixin],
  data() {
    return {
      realtime_timer: null,
      time_unit: ['day', 'week', 'month', 'year'],
      data_units: [],
      historical_data_units: ['power', 'current', 'electricity'],
      realtime_data_units: ["power", "current"],
      picked_unit: 'power',
      line_chart_default_setup: {
        tension: 0.1,
        pointRadius: 2,
        pointHoverRadius: 5,
        pointHitRadius: 50,
        pointBorderWidth: 2,
        type: "line",
        tension: .4,
        pointRadius: 0,
      },
      line_chart_instance: null,
      bar_chart_instance: null,
      line_chart_ctx: null,
      bar_chart_ctx: null,
    }
  },
  computed: {
    data_type() {
      return this.$store.getters.dataType;
    },
    time_format() {
      return this.$store.getters.historicalDataTimeFormat;
    },
    meter() {
      return this.$store.getters.selectedMeter;
    },
    scale_colors() {
      return this.$store.getters.scaleColors
    },
    picked_function() {
      return this.$store.getters.pickedFunction;
    },
    daily_bill() {
      return this.$store.getters.dailyBillThisMonth;
    }
  },
  watch: {
    time_format() {
      console.log('--chart-- time format changed');
      this.$store.dispatch('setSelectedMeter', this.meter.id);
      this.checkDataType();
    },
    meter() {
      console.log('--chart-- meter changed');
      if (this.picked_function === 'power-overview') {
        this.initChart();
      }
    },
    data_type() {
      console.log('--chart-- data type changed');
      this.$nextTick(() => {
        this.checkDataType();
        this.initChart();
      });
    },
    daily_bill() {
      console.log('--chart-- daily bill changed');
      this.initChart();
    },
    deep: true
  },
  mounted() {
    console.log('--chart-- render chart mounted');
    if (window.innerWidth < 768) {
      Chart.defaults.font.size = 10;
    } else if (window.innerWidth < 1150) {
      Chart.defaults.font.size = 12;
    } else {
      Chart.defaults.font.size = 14;
    }
    this.checkDataType();
    this.initChart();
  },
  methods: {
    checkDataType() {
      if (this.data_type === 'lineChart') {
        this.line_chart_ctx = this.$refs.lineChart;
        if (this.realtime_timer) {
          this.clearTimer();
        }
        if (this.time_format !== 'day') {
          this.data_units = ['electricity'];
          this.picked_unit = 'electricity';
        } else {
          this.data_units = this.historical_data_units;
        }
      } else if (this.data_type === 'barChart') {
        this.data_units = this.realtime_data_units;
        this.bar_chart_ctx = this.$refs.barChart;
        if (this.picked_function === 'power-overview') {
          this.setTimer();
        }
      }
    },
    async initChart() {
      console.log('--chart-- init chart');
      await this.destroyCharts();
      await this.renderCharts();
    },
    destroyCharts() {
      if (this.line_chart_instance) {
        console.log('--chart-- destroy line chart');
        this.line_chart_datasets = [];
        this.line_chart_instance.destroy();
      }
      if (this.bar_chart_instance) {
        console.log('--chart-- destroy bar chart');
        this.bar_chart_datasets = [];
        this.bar_chart_instance.destroy();
      }
    },
    setTimer() {
      this.clearTimer();
      this.realtime_timer = setInterval(() => {
        this.initChart();
      }, 180000); // refresh every 3 minutes
    },
    clearTimer() {
      if (this.realtime_timer) {
        clearInterval(this.realtime_timer);
        this.realtime_timer = null;
      }
    },
    async renderCharts() {
      if (!this.meter.bx_circuits) {
        return;
      }
      if (this.data_type === 'lineChart' && this.line_chart_ctx) {
        this.renderLineChart();
      } else
        if (this.data_type === 'barChart' && this.bar_chart_ctx) {
          if (this.picked_unit === 'electricity') {
            this.picked_unit = 'power';
          }
          this.renderBarChart();
        }
    },
    renderLineChart() {
      console.log('--chart-- render line chart');
      this.meter.bx_circuits.forEach((circuit, index) => {
        let scale_color = this.RGBformat(this.scale_colors[index]);
        let transparent_scale_color = this.RGBformat(this.scale_colors[index], 0.2);
        let dataset_data = [];
        let time = [];
        let dataset = {};

        if (this.picked_unit === 'electricity') {
          circuit.cumulative_data.forEach((data) => {
            // 累積電度
            // dataset_data.push(data.cumulative_ep);
            // 每一時間單位電度
            dataset_data.push(data.kWh);
            time.push(data.time);
          })
        } else {
          circuit.electricity_data.forEach((data) => {
            if (this.picked_unit === 'power') {
              dataset_data.push(data.power);
            } else if (this.picked_unit === 'current') {
              dataset_data.push(data.current);
            }
            time.push(data.time);
          })
        }
        let common_setup = {
          label: circuit.alias,
          data: dataset_data,
          borderColor: scale_color,
          pointBorderColor: scale_color,
          pointHoverBackgroundColor: scale_color,
          backgroundColor: transparent_scale_color,
          pointBackgroundColor: transparent_scale_color,
          hidden: index === 0 ? false : true,
        }

        this.line_chart_datasets.push(Object.assign(dataset, this.line_chart_default_setup, common_setup));
        this.line_chart_times = time;
        this.line_chart_labels = time;
      });
      this.line_chart_instance = new Chart(this.line_chart_ctx, this.line_chart_config);

      this.$store.commit('setShowSpinner', false);
    },
    async renderBarChart() {
      console.log('--chart-- render bar chart');
      let dataset_data = [];
      let bar_colors = [];
      let bar_chart_labels = [];
      let common_setup = {};
      let datasets = {};

      if (this.picked_function === 'bill-query') {
        if (this.daily_bill.length === 0) {
          return;
        }
        this.daily_bill.forEach((data) => {
          dataset_data.push(data.electricityCost);
          bar_chart_labels.push(data.time);
        });
        common_setup = {
          label: "TWD",
          backgroundColor: ['#0287d6'],
          borderRadius: 99,
          barPercentage: .4,
          hoverBackgroundColor: ['#ff5353'],
          data: dataset_data,
        }
      } else {
        await this.$store.dispatch('setRealtimeData');
        let realtime_data = this.$store.getters.realtimeData;

        // 將各線路的值進行加總
        this.meter.bx_circuits.forEach((circuit, index) => {
          if (this.picked_unit === 'power') {
            dataset_data.push(this.calculateSum(circuit.channels, JSON.parse(realtime_data.p), "p"));
          } else if (this.picked_unit === 'current') {
            dataset_data.push(this.calculateSum(circuit.channels, JSON.parse(realtime_data.i), "i"));
          }
          bar_colors.push(this.RGBformat(this.scale_colors[index]))
          bar_chart_labels.push(circuit.alias);
        });
        common_setup = {
          label: this.picked_unit == "current" ? "Ampere" : "kWatt",
          backgroundColor: bar_colors,
          borderWidth: 1,
          data: dataset_data,
        }
      }
      this.bar_chart_datasets.push(Object.assign(datasets, common_setup));
      this.bar_chart_labels = bar_chart_labels;
      this.bar_chart_instance = new Chart(this.bar_chart_ctx, this.bar_chart_config);

      this.$store.commit('setShowSpinner', false);
    },
    calculateSum(channels, data, string) {
      const channel_list = channels.split(',');
      let sum = 0;
      channel_list.forEach(channel => {
        const key = string.toUpperCase() + channel[0] + (Number(channel[1]) - 1);
        sum += parseFloat(data[key]) * 1000000;
      });
      return sum / 1000000;
    },
    // TODO: export to pdf
    getCanvasContent() {
      const canvas = this.$refs.myCanvas;
      const content = canvas.toDataURL('image/png');
      this.$store.commit('setCanvasContent', {
        channelId: this.circuit.id,
        content: content,
      });
    },
    pickUnit(type) {
      this.picked_unit = type;
      this.initChart();
    },
    switchTimeFormat(time_format) {
      this.$store.commit('setHistoricalDataTimeFormat', time_format);
    },
    dataTypeFormat(type) {
      switch (type) {
        case "power":
          return "功率"
        case "current":
          return "電流"
        default:
          return "電度"
      }
    },
    timeUnitFormat(unit) {
      switch (unit) {
        case "year":
          return "年度趨勢"
        case "month":
          return "當月趨勢"
        case "week":
          return "本週趨勢"
        default:
          return "當日趨勢"
      }
    }
  },
  beforeDestroy() {
    console.log('--chart-- before destroy');
    this.clearTimer();
    this.destroyCharts();
  }
}
</script>
<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 3px;
}

.header .switch-btn {
  cursor: pointer;
  background-color: var(--bx-unselected-btn);
  font-size: .7rem;
  font-weight: bolder;
  padding: .6rem;
  text-align: center;
  display: flex;
  align-items: center;
}

.header .switch-data-type {
  display: flex;
}

.header .switch-time-format {
  display: flex;
}

.header .chart-title {
  font-size: 1rem;
  font-weight: bolder;
  line-height: normal;
  margin-left: 1rem;
}

.header .selected {
  background-color: var(--bx-green);
  color: white;
  font-weight: normal;
}

@media (max-width: 420px) {
  .header .switch-btn {
    max-width: calc(.7rem *2 + .6rem * 2 + 2px);
  }
}

@media (min-width: 1150px) {
  .header .switch-btn {
    padding: 0 1.2rem 0 1.2rem;
    height: 2.5rem;
    font-size: .9rem;
  }
}
</style>
